import { useMemo } from "react";
import { useAuth } from "../context/authContext";
import pageRoutes from "../data/pageRoutes";
import { ROUTES } from "../constants";
import { useOptions } from "../context/optionContext";
import { resolveEnabledAdminModules } from "../utilities/adminModules";
import { canAccessSettings, filterPageRoutesByAccess } from "../utilities/pageAccess";

const useAccessiblePages = () => {
	const { hasPermission, user } = useAuth();
	const { optionKeys } = useOptions();

	return useMemo(() => {
		const enabledAdminModuleSet = new Set(resolveEnabledAdminModules(optionKeys));
		const isSuperAdmin = Number(user?.user_id) === 1;
		return filterPageRoutesByAccess(pageRoutes, hasPermission, user).filter((page) => {
			if (isSuperAdmin) return true;
			if (page.href === ROUTES.ANALYTICS) return enabledAdminModuleSet.has("ITEMS_TEXT.ORDER_ANALYTICS");
			if (page.href === ROUTES.USER_ANALYTICS) return enabledAdminModuleSet.has("ITEMS_TEXT.USER_ANALYTICS");
			return true;
		}).map((page) => {
			if (page.href === ROUTES.SETTINGS && canAccessSettings(user)) {
				return {
					...page,
					href: `${ROUTES.ADMIN}?tab=settings`,
				};
			}
			return page;
		});
	}, [hasPermission, optionKeys, user]);
};

export default useAccessiblePages;
